var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack548({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.49,11.31h-1V11a1.68,1.68,0,0,1,.16-.79,2.46,2.46,0,0,1,.64-.71A6.07,6.07,0,0,0,8.87,9,.71.71,0,0,0,9,8.61a.72.72,0,0,0-.26-.55,1,1,0,0,0-.69-.23,1,1,0,0,0-.69.24A1.25,1.25,0,0,0,7,8.8L6,8.67a1.66,1.66,0,0,1,.6-1.18A2.09,2.09,0,0,1,8,7a2.17,2.17,0,0,1,1.5.49,1.5,1.5,0,0,1,.56,1.15,1.34,1.34,0,0,1-.2.69,4.41,4.41,0,0,1-.88.88,1.66,1.66,0,0,0-.43.47A1.52,1.52,0,0,0,8.49,11.31Zm-1,1.47V11.69h1.1v1.09Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack548);
export default __webpack_public_path__ + "static/media/Symbolpack_5_48.78bbe4033562e0714f17f79786c3060b.svg";
export { ForwardRef as ReactComponent };